import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { calculateTotals, cuFormat } from "../../../../components/table/coreUiTable/Format";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";

const DiscountsTable = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [totalsForExport, setTotalsForExport] = useState([]);
  const [totalSlots, setTotalSlots] = useState([]);

  const {
    data = [],
    colHeaders = [],
    columns = [],
    rowCalculations = [],
    rawDataLink
  } = useSelector((state) => state.discounts.chartsData.table);

  const formattedSlots = cuFormat({ headers: colHeaders, columns: columns });

  // The totals row is recomputed from the rows the search box currently leaves visible, so it
  // tracks the search instead of being a static row the backend appended to `data`.
  useEffect(() => {
    const totals = ["Total"];

    const totalRow = colHeaders.slice(1).map((header, index) => {
      const renderFunc = formattedSlots[header];
      const calculation = rowCalculations[index + 1];
      // A column with no calculation (or a cached pre-rowCalculations payload) gets a blank cell
      // rather than throwing inside calculateTotals.
      const calculatedValue = calculation
        ? calculateTotals(filteredData, calculation, colHeaders, header)
        : "";

      totals.push(calculatedValue);

      return renderFunc({ [header]: calculatedValue }, {});
    });

    setTotalSlots(totalRow);
    setTotalsForExport(totals);
  }, [filteredData]);

  return (
    <TableWithCustomSearch
      fileName="discounts"
      data={data}
      colHeaders={colHeaders}
      columns={columns}
      rawDataLink={rawDataLink}
      onFilteredItemsChange={setFilteredData}
      itemsPerPage={10}
      additionalDataToExport={totalsForExport}
      footerSlot={
        filteredData.length > 1 ? (
          <tfoot>
            <tr>
              <td />
              <td>Total</td>
              {totalSlots}
            </tr>
          </tfoot>
        ) : null
      }
    />
  );
};

export default DiscountsTable;
